import React from "react";
import PropTypes from "prop-types";
import {
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Switch,
  Select,
  Grid,
  GridItem,
  Button,
  Spacer,
  Tooltip,
  Badge,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  Icon,
  Flex,
} from "@chakra-ui/react";
import moment from "moment";
const DateRender = ({ value }) => {
  return Object.values(value).map((item, i) => (
    <Badge
      key={"badge_" + i}
      style={{ textTransform: "lowercase" }}
      ml="1"
      fontSize="0.8em"
      colorScheme="green"
    >
      {item}
    </Badge>
  ));
};

DateRender.propTypes = {
  value: PropTypes.string,
};

export default DateRender;
